export default __webpack_public_path__ + "static/arte-70a21e301977d40b3449b005081c50e0.png";